// @ts-nocheck
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {getPaykuTransactionStatus, postPaykuDeposit} from "../../services/wallet/payku.service";

export const usePostPaykuDeposit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postPaykuDeposit,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ["userWallet"]});
    },
    onError: _error => {},
  });
};

export const usePaykuTransactionStatus = (orderId, enabled = false) => {
  return useQuery({
    queryKey: ["paykuTransactionStatus", orderId],
    queryFn: () => getPaykuTransactionStatus(orderId),
    enabled: enabled && !!orderId,
    refetchInterval: data => {
      // Stop polling if transaction is completed, rejected, or expired
      const status = data?.data?.data?.status;
      if (["approved", "completed", "rejected", "expired"].includes(status)) {
        return false;
      }
      return 10000; // Poll every 10 seconds for pending transactions
    },
    retry: false,
  });
};
